import { useAction } from '@reatom/npm-react'

import { routerActions } from '@root/shared/lib/react-router'

import {
  AuthRoute,
  FunExploreRoute,
  NftRoute,
  PremiumRoute,
  TradeRoute,
  RootRoute,
  ProfileReferralLeaderboardRoute,
  ProfileReferralUsersRoute,
  ProfileTradingLeaderboardRoute,
  ProfileRoute,
  WalletManagerWalletRoute,
  WalletManagerRoute,
  NewWalletRoute,
  WalletSwapRoute,
  WalletTransferRoute,
} from '../model'

import type { Network } from '@root/entities/network'
import type { PairAddress } from '@root/entities/pair'
import type { DelugeId } from '@root/entities/user-short'
import type { WalletId } from '@root/entities/wallet/model'

export const useAppRoutes = () => {
  const navigate = useAction(routerActions.navigate)

  return {
    navigate,
    navigateToTrading: (pairAddress: PairAddress, network: Network.Network) =>
      navigate(TradeRoute.build({ pairAddress, network })),

    navigateToAuth: () => navigate(AuthRoute.build()),

    navigateToPremiumIndex: () => navigate(PremiumRoute.build()),

    navigateToFunExplore: () => navigate(FunExploreRoute.build()),

    navigateToNft: () => navigate(NftRoute.build()),

    navigateToRoot: () => navigate(RootRoute.build()),

    navigateToProfileIndex: () => navigate(ProfileRoute.build({})),

    navigateToProfileReferralLeaderboard: () =>
      navigate(ProfileReferralLeaderboardRoute.build()),

    navigateToProfileTradingLeaderboard: () =>
      navigate(ProfileTradingLeaderboardRoute.build()),

    navigateToProfileReferralUsers: () =>
      navigate(ProfileReferralUsersRoute.build()),

    navigateUserProfile: (delugeId: DelugeId) =>
      navigate(ProfileRoute.build({ delugeId })),

    navigateToWalletManager: () => navigate(WalletManagerRoute.build()),

    navigateToWalletManagerWallet: (walletId: WalletId) =>
      navigate(WalletManagerWalletRoute.build({ walletId })),

    navigateToNewWallet: () => navigate(NewWalletRoute.build()),

    navigateToWalletSwap: (walletId: WalletId) =>
      navigate(WalletSwapRoute.build({ walletId: walletId })),

    navigateToWalletTransfer: (walletId: WalletId) =>
      navigate(WalletTransferRoute.build({ walletId: walletId })),
  }
}
